import { Box, Button, Flex, Typography } from "@jewlr/storybook/core"
import React from "react"
import styled from "styled-components"

// import { to_currency } from "helpers/number"
// import useWindowDimensions from "helpers/window-dimensions"

const SubscribeWrapper = styled(Flex).attrs((props) => ({
  alignItems: { _: "flex-start", tablet: "center" },
  containWide: true,
  flexDirection: { _: "column", tablet: "row" },
  gap: { tablet: 6 },
  height: { tablet: "200px" },
  justifyContent: "space-between",
  px: props.showWinContest ? { _: 2, large: "60px" } : { _: 2, tablet: "60px" },
  py: { _: 4, tablet: "10px" },
}))``

const SubscribeHeading = styled(Typography).attrs((props) => ({
  as: "h2",
  flexShrink: 0,
  fontSize: { _: "64px", desktop: "100px" },
  fontWeight: "700",
  lineHeight: { _: "120%", desktop: "100%" },
  mb: { _: 3, tablet: 0 },
  ...props,
}))`
  white-space: nowrap;
`

const SubscribeMsg = styled(Typography).attrs((props) => ({
  fontSize: { _: "20px", desktop: "24px" },
  fontWeight: { _: 400, desktop: 600 },
  lineHeight: { _: "124%", desktop: "100%" },
  mb: { _: 3, tablet: 1, xlarge: 0 },
  mr: { xlarge: 8 },
  textAlign: { tablet: "right" },
  ...props,
}))`
  white-space: nowrap;
`

const GetYourCode = styled(Button).attrs({
  bg: "blackPrint",
  color: "white",
  fontSize: "16px",
  fontWeight: "600",
  height: "44px",
  lineHeight: "100%",
  textTransform: "uppercase",
  width: { _: "100%", tablet: "230px", widescreen: "300px" },
})``

const FooterSubscribe = () => {
  // const is_ca = IS_CA()
  // const is_us = IS_US()
  // const is_uk = IS_UK()
  // const is_au = IS_AU()

  // const { isMobile } = useWindowDimensions()
  const showWinContest = true

  const triggerPopup = () => {
    console.log("Popup trigger")
    try {
      window.DIGIOH_API.LIGHTBOX.loadLightbox(
        "d9e77ec8-71be-431a-838d-8e069ede7fab"
      )
      // window.DIGIOH_API.LIGHTBOX.loadLightbox(
      //   showWinContest
      //     ? popupCloseExp === 1
      //       ? "d9e77ec8-71be-431a-838d-8e069ede7fab" // 2025 MD (only close with X button) (box 294273)
      //       : "96ec704c-c03d-477b-97b1-a6de3687a708" // 2025 MD (box 293322)
      //     : "a212f760-6f35-4cd0-806e-e3033828137b" // Save 15% form
      // )
      // if (isMobile) {
      //   // call the mobile Digioh
      //   if (is_us) {
      //     console.log("attentive mobile us: 383401")
      //     window.__attentive.trigger(null, null, null, 383401)
      //   } else if (is_ca) {
      //     console.log("attentive mobile us: 289587")
      //     window.__attentive.trigger(null, null, null, 289587)
      //   } else if (is_uk || is_au) {
      //     console.log("Digiog mobile UK&AU : 250908")
      //     window.DIGIOH_API.LIGHTBOX.loadLightbox(
      //       "324465c8-d1ea-4967-adb1-b3c23e80cfd2"
      //     )
      //   }
      // } else {
      //   //call the desktop Digioh
      //   if (is_us) {
      //     console.log("Digioh desktop us: 261001")
      //     window.DIGIOH_API.LIGHTBOX.loadLightbox(
      //       "29e224ea-4754-4f9d-ac44-92d2208d0e70"
      //     )
      //   } else if (is_ca) {
      //     console.log("Digioh desktop is_ca: 256760")
      //     window.DIGIOH_API.LIGHTBOX.loadLightbox(
      //       "30e288cf-7f80-41a9-b93a-d708cbc20cae"
      //     )
      //   } else if (is_uk || is_au) {
      //     console.log("Digiog desktop UK&AU : 250907")
      //     window.DIGIOH_API.LIGHTBOX.loadLightbox(
      //       "449283ef-e8e8-41b3-acd9-b21aac38ea54"
      //     )
      //   }
      // }
    } catch (err) {
      console.log("Error loading popup: ", err)
    }
  }

  return (
    <Box bg="primary" color="white">
      <SubscribeWrapper showWinContest={showWinContest}>
        <SubscribeHeading>
          Stay
          <wbr /> in touch
        </SubscribeHeading>
        <Flex
          alignItems={{
            _: "flex-start",
            tablet: "flex-end",
            xlarge: "center",
          }}
          flexDirection={{ _: "column", xlarge: "row" }}
          width={{ _: "100%", tablet: "auto" }}
        >
          <SubscribeMsg>
            {showWinContest ? (
              <>
                Subscribe to our emails
                <wbr /> and save an extra 15%
              </>
            ) : (
              <>
                Subscribe to our
                <Box
                  as="br"
                  display={{ _: "none", tablet: "block", widescreen: "none" }}
                />{" "}
                emails and save 15%
              </>
            )}
          </SubscribeMsg>
          <GetYourCode onClick={() => triggerPopup()}>
            Get your code
          </GetYourCode>
        </Flex>
      </SubscribeWrapper>
    </Box>
  )
}

export default FooterSubscribe
